var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"link",attrs:{"to":{ name: 'ask-anything' }}},[_c('div',{staticClass:"link-icon"},[_c(_setup.AskSvgIcon)],1),_vm._v(" "),_c('span',{staticClass:"link-text"},[_vm._v("\n    Ask Anything\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }